export default {
  root: {
    width: '20px'
  }
}
